import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Redefinemetaverse() {
  return (
    <section className="redefine_metaverse p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Redefine User Interactions with Custom Metaverse</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="redefine_meta_box">
                  <div className="redefine_meta_content">
                    <h5>Enhanced User Engagement</h5>
                    <p>
                      Foster deeper user connections with interactive and
                      immersive virtual experiences.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="redefine_meta_box">
                  <div className="redefine_meta_content">
                    <h5>Scalable Solutions</h5>
                    <p>
                      Develop scalable metaverse applications that grow with
                      your business needs.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="redefine_meta_box">
                  <div className="redefine_meta_content">
                    <h5>Increased Security</h5>
                    <p>
                      Protect user data and transactions with advanced
                      blockchain and encryption technologies.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="redefine_meta_box">
                  <div className="redefine_meta_content">
                    <h5>Seamless Integration</h5>
                    <p>
                      Integrate metaverse solutions with existing systems for
                      improved functionality and user experience.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="redefine_meta_box">
                  <div className="redefine_meta_content">
                    <h5>Innovative Marketing</h5>
                    <p>
                      Leverage virtual environments for creative and impactful
                      marketing campaigns.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="redefine_meta_box">
                  <div className="redefine_meta_content">
                    <h5>Customized Experiences</h5>
                    <p>
                      Tailor virtual environments to reflect your brand identity
                      and meet specific business objectives.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Redefinemetaverse;
